import { IoArrowUpOutline } from "react-icons/io5";
import { IoArrowDownOutline } from "react-icons/io5";
const IncDecIndicator = ({ type, value }) => {
  return (
    <div
      className={`d-flex gap-1 align-items-center ${
        type === "inc" ? "text-success" : "text-danger"
      }`}
    >
      <div>
        {type === "inc" ? (
          <IoArrowUpOutline size={16} />
        ) : (
          <IoArrowDownOutline size={16} />
        )}
      </div>
      <p className="f-6 m-0">{value}</p>
    </div>
  );
};

export default IncDecIndicator;
